// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthVm$PorterinFeature from "../../../../view-model/AuthVm.mjs";
import * as AuthStore$PorterinFeature from "../../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../../domain/helpers/AuthUtils.mjs";
import * as CityContext$PorterinFeature from "../../../../../../contexts/city-context/CityContext.mjs";
import * as AuthInputCmp$PorterinFeature from "../../common/AuthInputCmp.mjs";
import * as CommonHelper$PorterinFeature from "../../../../../../shared/core/helpers/CommonHelper.mjs";
import * as AuthButtonCmp$PorterinFeature from "../../common/AuthButtonCmp.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as SignupFormState$PorterinFeature from "./SignupFormState.mjs";
import * as SignupFormInterface$PorterinFeature from "./SignupFormInterface.mjs";
import * as SignupFormModuleScss from "../../../styles/SignupForm.module.scss";
import * as SignupWhatsappConsentCmp$PorterinFeature from "./SignupWhatsappConsentCmp.mjs";

var styles = SignupFormModuleScss;

function SignupFormCmp(Props) {
  var set_auth_state = Props.set_auth_state;
  var prefill = Props.prefill;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match$1 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var set_user = match$1.set_user;
  var user = match$1.user;
  var match$2 = React.useState(function () {
        return AuthVm$PorterinFeature.prefillName(prefill).length === 0;
      });
  var setIsNameEmpty = match$2[1];
  var match$3 = React.useState(function () {
        return true;
      });
  var setIsEmailEmpty = match$3[1];
  var match$4 = React.useState(function () {
        return SignupFormState$PorterinFeature.initialFormState(AuthVm$PorterinFeature.prefillName(prefill));
      });
  var setInitialInput = match$4[1];
  var match$5 = React.useState(function () {
        return true;
      });
  var whatsappConstent = match$5[0];
  var match$6 = React.useState(function () {
        
      });
  var setResponse = match$6[1];
  var response = match$6[0];
  var form = SignupFormInterface$PorterinFeature.Form.useForm(match$4[0], (function (output, callbacks) {
          SignupFormState$PorterinFeature.onFormSubmit(output, callbacks, setResponse, set_auth_state, user, set_user, whatsappConstent);
        }));
  var getFieldError = function (field, _callback) {
    Curry._1(form.dirty, undefined);
    return CommonHelper$PorterinFeature.getError(field);
  };
  var getEmailFieldError = function (field, _callback) {
    var match = Curry._1(form.dirty, undefined);
    if (response === undefined) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    if (response.TAG === /* Ok */0) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    if (match) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    var message = response._0;
    if (AuthUtils$PorterinFeature.checkErrorIsEmail(message)) {
      return message;
    }
    
  };
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setInitialInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  var match$7 = Curry._1(form.dirty, undefined);
  var tmp;
  if (response !== undefined && !(response.TAG === /* Ok */0 || match$7)) {
    var message = response._0;
    tmp = AuthUtils$PorterinFeature.checkErrorIsEmail(message) ? null : React.createElement("div", {
            className: styles["submit-button-error"]
          }, message);
  } else {
    tmp = null;
  }
  return React.createElement("form", {
              className: styles["signup-form"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement("div", {
                  className: styles["field-wrapper"]
                }, React.createElement(AuthInputCmp$PorterinFeature.make, {
                      label: AuthStore$PorterinFeature.Signup.form_label_name,
                      is_required: true,
                      is_filled: match$2[0],
                      children: React.createElement("input", {
                            className: styles["mobile-input"],
                            autoFocus: true,
                            disabled: form.submitting,
                            placeholder: "",
                            type: "text",
                            value: form.input.name,
                            onBlur: (function (param) {
                                Curry._1(form.blurName, undefined);
                              }),
                            onChange: (function ($$event) {
                                Curry._1(setIsNameEmpty, (function (param) {
                                        return $$event.target.value.length === 0;
                                      }));
                                Curry._2(form.updateName, (function (input, value) {
                                        return {
                                                name: value,
                                                email: input.email
                                              };
                                      }), $$event.target.value);
                              })
                          }),
                      error: getFieldError(form.nameResult, (function (field_errors) {
                              return field_errors.name;
                            })),
                      styles: styles.style
                    }), React.createElement("div", {
                      className: styles.spacing
                    }), React.createElement(AuthInputCmp$PorterinFeature.make, {
                      label: AuthStore$PorterinFeature.Signup.form_label_email,
                      is_required: true,
                      is_filled: match$3[0],
                      children: React.createElement("input", {
                            className: styles["mobile-input"],
                            disabled: form.submitting,
                            placeholder: "",
                            type: "text",
                            value: form.input.email,
                            onBlur: (function (param) {
                                Curry._1(form.blurName, undefined);
                              }),
                            onChange: (function ($$event) {
                                Curry._1(setIsEmailEmpty, (function (param) {
                                        return $$event.target.value.length === 0;
                                      }));
                                Curry._2(form.updateEmail, (function (input, value) {
                                        return {
                                                name: input.name,
                                                email: value
                                              };
                                      }), $$event.target.value);
                              })
                          }),
                      error: getEmailFieldError(form.emailResult, (function (field_errors) {
                              return field_errors.email;
                            })),
                      styles: styles.style
                    }), React.createElement(SignupWhatsappConsentCmp$PorterinFeature.make, {
                      consent: whatsappConstent,
                      set_consent: match$5[1]
                    })), React.createElement("div", {
                  className: styles["submit-button-wrapper"]
                }, React.createElement(AuthButtonCmp$PorterinFeature.make, {
                      is_disabled: !Curry._1(form.valid, undefined) || form.submitting,
                      class_name: styles["submit-container"],
                      event_name: AuthStore$PorterinFeature.Signup.ga_form_submit_event,
                      category: match.category,
                      submit_text: AuthStore$PorterinFeature.Signup.submit_button,
                      event_label: AuthUtils$PorterinFeature.signupGAEventLabel(form.input.name, form.input.email, whatsappConstent),
                      mobile: AuthUtils$PorterinFeature.mobile(user)
                    }), tmp));
}

var make = SignupFormCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
